export default __webpack_public_path__ + "static/media/hero-home-page-background-mobile.12aaa88e.png";